import React from "react";

import FullPageLayout from "../../layouts/FullPage";
import BigMessage from "../../components/BigMessage";
import image from "./no-sign-replacement.jpg";

const NotFoundPage = () => (
  <FullPageLayout backgroundImage={image}>
    <BigMessage title="Page Not Found" />
  </FullPageLayout>
);

export default NotFoundPage;
